<template>
  <div class="t-card" style="padding: 0">
    <div v-if="!currentWorkspace">
      <empty width="200px" v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
        <h5 class="text-center" id="myText">
          {{ $t("workspace.empty") }}
        </h5>
      </empty>
    </div>
    <div v-else>
      <div class="t-card--title-big" @click="showWorkspacePopup = !showWorkspacePopup" @mouseleave="showWorkspaceHeader = false">
        <div class="element-popup--container" :class="{ active: showWorkspaceHeader }">
          <div class="element-title hand" @click="showWorkspaceHeader = !showWorkspaceHeader">
            {{ this.currentWorkspace.name }}
            <span><img src="@/assets/images/arrow-down.png"/></span>
          </div>
          <div class="element-popup">
            <div class="workspace-popup--input-container">
              <img class="workspace-popup--input-icon" src="@/assets/images/search-icon.png" />
              <input class="workspace-popup--input" v-model="workspaceNameFilter" type="text" :placeholder="$t('workspace.name')" />
            </div>
            <div v-if="pagination && pagination.docs">
              <div
                v-for="workspace in pagination.docs"
                :key="workspace._id"
                class="workspace-popup--workspace-item"
                :class="{ active: workspace.active }"
                @click="selectWorkspace(workspace)"
              >
                <i class="iconoir-hexagon"></i> {{ workspace.name }}
              </div>
              <div class="workspace-popup--pagination">
                <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a href="/workspace">
        <section class="workspace-section">
          <i class="iconoir-hexagon font-size-20"></i>
          <b class="workspace-section--name">
            {{ this.currentWorkspace.name }}
          </b>
          <i class="iconoir-arrow-down-right"></i>
        </section>
      </a>

      <div v-if="organizationPagination && organizationPagination.docs">
        <company-item v-for="organization in organizationPagination.docs" :key="organization._id" :organization="organization" />
        <div class="d-flex mt-3 justify-content-center" v-if="organizationPagination.docs.length > 0">
          <b-pagination
            v-model="organizationRequest.options.page"
            :total-rows="organizationPagination.totalDocs"
            :per-page="organizationPagination.limit"
            limit="10"
            size="sm"
          ></b-pagination>
        </div>
      </div>

      <div v-if="isAdminOrOwnerOfAnyWorkpace" class="organization-members">
        <div class="organization-members--title">{{ $t("workspace.members") }}</div>
        <div class="organization-members--items pb-4">
          <div v-for="(member, index) in workspaceMembers" :key="member._id" class="organization-members--item " :style="{ left: `${index + 1 + index * 0.5}rem` }">
            <task-avatar class="ml-1 mt-1" :account="member" size="xs" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyItem from "./company-item";

export default {
  components: { CompanyItem },
  data() {
    return {
      showWorkspaceHeader: false,
      showWorkspacePopup: false,
      workspaceNameFilter: undefined,

      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
      },
      organizationRequest: {
        options: { page: 1, limit: 3, sort: { name: "asc" } },
      },
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    organizationRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginateOrganizations());
      },
    },
    workspaceNameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
      this.debounce(() => this.paginate());
    },

    currentWorkspace: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => {
          this.paginateOrganizations();
          this.paginateWorkspaceMembers();
        });
      },
    },
  },

  computed: {
    pagination() {
      return this.$store.getters["switchWorkspace/pagination"];
    },
    workspaceMembers() {
      return this.$store.getters["workspace/paginationMember"]?.docs ?? [];
    },

    organizationPagination() {
      return this.$store.getters["organization/pagination"];
    },
    isLoading() {
      return this.$store.getters["switchWorkspace/isLoading"];
    },
  },
  mounted() {
    this.paginate();
    this.paginateWorkspaceMembers();
  },

  methods: {
    selectWorkspace(workspace) {
      this.showWorkspaceHeader = false;
      this.$store.commit("switchWorkspace/selected", workspace);
    },
    async paginate() {
      await this.$store.dispatch(`switchWorkspace/paginate`, { pagination: { ...this.request } });
    },
    paginateWorkspaceMembers() {
      if (!this.isWorkspaceAdmin) {
        return;
      }
      this.$store.dispatch(`workspace/paginateMember`, { pagination: {}, id: this.currentWorkspace?._id });
    },
    paginateOrganizations() {
      if (!this.currentWorkspace) {
        return;
      }
      this.organizationRequest.query = {
        ...this.organizationRequest.query,
        workspace: { value: this.currentWorkspace._id, isObject: true },
      };
      this.$store.dispatch(`organization/paginate`, this.organizationRequest);
    },
  },
};
</script>

<style></style>
